<h3>{{ 'LOGOUT_CONFIRM_DIALOG.TITLE' | translate }}</h3>

<span class="dps-icon dps-icon-warning text-8xl text-orange-500"></span>

<div class="flex align-items-center gap-2">
  <p-checkbox inputId="logoutFromAllDevicesCheckbox" [(ngModel)]="logoutFromAllDevices" binary />
  <label for="logoutFromAllDevicesCheckbox">
    {{ 'LOGOUT_CONFIRM_DIALOG.LOGOUT_FROM_ALL_DEVICES' | translate }}
  </label>
</div>

<div class="flex w-full justify-content-evenly">
  <p-button
    text
    autofocus
    severity="secondary"
    label="{{ 'GENERIC_CONFIRM_DIALOG.CANCEL_BTN' | translate }}"
    (onClick)="dialogRef.close()"
  />

  <p-button
    severity="danger"
    label="{{ 'GENERIC_CONFIRM_DIALOG.CONFIRM_BTN' | translate }}"
    (onClick)="dialogRef.close({ logoutFromAllDevices: logoutFromAllDevices() })"
  />
</div>
